import i18n from "@/i18n"

export default {
  path: "/",
  component: () => import("./index.vue"),
  name: "dashboard",
  meta: {
    title: "dashboard.title"
  }
}
